<template>
  <div
    class="modal fade"
    id="settlementDownloadModal"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-hidden="true"
          >
            ×
          </button>
          <h4 class="modal-title">
            <b>{{ lang.SDM000 }}</b>
          </h4>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label for="inputSettlementNumber" class="col-md-4 control-label">{{
              lang.SDM001
            }}</label>
            <div class="col-md-8">
              <input
                class="form-control"
                type="text"
                id="inputSettlementNumber"
                v-model="settlementNumber"
              />
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-raised btn-success pull-left"
            id="createNewSettlementButton"
            v-if="globals.isPaymentsEditingAllowed"
            :disabled="!!settlementNumber"
            @click="createNewSettlementList()"
          >
            {{ lang.SDM002 }}
          </button>
          <button type="button" class="btn btn-raised" data-dismiss="modal">
            {{ lang.SDM003 }}
          </button>
          <button
            type="button"
            class="btn btn-raised dialog-btn-primary"
            :disabled="!settlementNumber"
            @click="downloadSettlementList()"
          >
            {{ lang.SDM004 }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SettlementDownloadModal",
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      settlementNumber: "",
      lang: {
        SDM000: "Download Invoice List",
        SDM001: "Invoice Number",
        SDM002: "Create new invoice list",
        SDM003: "Cancel",
        SDM004: "Download",
        SDM005: "Invoice list export failed",
        SDM006: "Invoice list created",
        SDM007: "Invoice list creation failed",
        SDM008: "Invalid invoice number",
      },
    };
  },
  watch: {
    showModal() {
      if (this.showModal) {
        this.openModal();
      } else {
        this.closeModal();
      }
    },
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
    },
  },
  mounted() {
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);
    $("#settlementDownloadModal").on("hide.bs.modal", (e) =>
      this.$emit("closeModal")
    );
    $("#settlementDownloadModal").on("hidden.bs.modal", (e) => {
      this.$emit("modalClosed");
    });
  },
  methods: {
    openModal() {
      this.settlementNumber = "";
      this.$nextTick(() => {
        $("#settlementDownloadModal").modal("show");
      });
    },
    closeModal() {
      $("#settlementDownloadModal").modal("hide");
    },
    downloadSettlementList() {
      this.settlementNumber = this.settlementNumber
        .replace(" ", "")
        .replace("\n", "");
      if (
        this.settlementNumber.length !== 8 ||
        !this.settlementNumber.match(/^[0-9]+$/)
      ) {
        console.error("Invalid SettlementNumber:", this.settlementNumber);
        this.globals.showErrorSnackbar(this.lang.SDM008);
        return;
      }

      let queryString = `api/Settlement/SettlementNumber/${this.settlementNumber}/Export`;
      $.ajax({
        method: "GET",
        url: queryString,
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          if (!data || !data[0] || !data[0].DownloadId) {
            console.error("Missing DownloadId");
            this.globals.showErrorSnackbar(this.lang.SDM005);
            return;
          }
          this.globals.downloadFile(data[0].DownloadId);
          this.$emit("closeModal");
        },
        error: () => {
          console.error("Error on POST in downloadSettlementList()");
          this.globals.showErrorSnackbar(this.lang.SDM005);
        },
      });
    },
    createNewSettlementList() {
      let queryString = `api/Settlement`;

      $.ajax({
        method: "POST",
        url: queryString,
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          if (data.Error) {
            console.error(data.Error);
            this.globals.showErrorSnackbar(data.Error);
            return;
          }
          this.settlementNumber = data.SettlementNumber;
          this.globals.showSuccessSnackbar(this.lang.SDM006);
        },
        error: () => {
          console.error("Error on POST in createNewSettlementList()");
          this.globals.showErrorSnackbar(this.lang.SDM007);
        },
      });
    },
  },
};
</script>

<style scoped>
#createNewSettlementButton {
  left: 0;
  padding-left: 10px;
  padding-right: 10px;
}
</style>



// WEBPACK FOOTER //
// SettlementDownloadModal.vue?1ddf1248